import {useCallback, useState} from "react";


export default function useBottomSheet({initialState = true, onClose}: BSLProps) {
	  const [isOpen, setIsOpen] = useState(initialState);
	  
	  const handleClose = useCallback((event, reason) => {
			 if (reason === "backdropClick" || reason === "escapeKeyDown") {
					return;
			 }
			 setIsOpen(false);
			 onClose();
	  }, []);
	  
	  const handleOpen = useCallback(() => {
			 setIsOpen(true);
	  }, []);
	  
	  const values: BottomSheetProps = {isOpen, handleClose, handleOpen};
	  return values;
}


export interface BottomSheetProps {
	  isOpen: boolean;
	  handleClose: (event: React.SyntheticEvent, reason: string) => void;
	  handleOpen: () => void;
}

export interface BSLProps {
	  uid: string;
	  onClose: () => void;
}